import { extend, ValidationProvider, ValidationObserver } from 'vee-validate'
import { length, required, email, max } from 'vee-validate/dist/rules'

export const init = (Vue) => {
  extend('length', length)
  extend('max', {
    ...max,
    message: () => ``,
  })
  extend('required', {
    ...required,
    message: (field) => `${field} is required`,
  })
  extend('email', {
    ...email,
    message: 'Email is invalid',
  })
  extend('mottoEmailDomain', {
    message: 'New email must belong to "@mottomortgage.com" domain.',
    validate: (value) => value.endsWith('@mottomortgage.com'),
  })
  extend('validPhoneNumber', {
    validate: (value) => value.length === 0 || value.length === 12,
  })

  Vue.component('ValidationProvider', ValidationProvider)
  Vue.component('ValidationObserver', ValidationObserver)
}
